module.exports = __webpack_public_path__ + "img/material.dfa91e33.webp";